import { render, staticRenderFns } from "./Tour2Boxes.vue?vue&type=template&id=73512dd7&"
import script from "./Tour2Boxes.vue?vue&type=script&lang=js&"
export * from "./Tour2Boxes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports